module.exports = __webpack_public_path__ + "img/project9_5.jpg.d582f169.webp";